export default "__VITE_ASSET__b2126434__"